import { Scrollbox as ScrollboxPrimitive, Typography } from "@packages/ds";
import styled from "styled-components";

import Search, { Icon } from "ds/Search";
import { Search as SearchPrimitive } from "ds/Search/Search.styles";

export const SearchInput = styled(Search)`
  height: 57px;
  padding-left: 24px;
  background-color: var(--mode-bg-neutral-weaker);

  :has(${SearchPrimitive}:focus) {
    ${Icon} {
      fill: var(--mode-vector-neutral-strong);
    }
  }

  ${SearchPrimitive} {
    padding-left: 5px;
    &::placeholder {
      font-size: 14px;
      line-height: 24px;
      color: var(--mode-text-neutral-default-weak);
    }

    &:focus {
      &::placeholder {
        color: var(--mode-text-neutral-weakest);
      }
    }
  }

  ${Icon} {
    fill: var(--mode-vector-neutral-default);
  }
`;

export const NoScroll = styled.div`
  padding: 8px 0;
`;

export const Scrollbox = styled(ScrollboxPrimitive)`
  height: 332px;
  .simplebar-content-wrapper {
    padding: 8px 12px 8px 0;
  }
`;

export const Environments = styled.div`
  padding: 0 8px;
`;

export const Empty = styled(Typography.BodyText)`
  margin: 8px 0 0 16px;
`;
